var Fily;
(function (Fily) {
    var Twitter;
    (function (Twitter) {
        Twitter.embed = function () {
            if (typeof window.twttr !== 'undefined') {
                window.twttr.widgets.load();
            }
        };
    })(Twitter = Fily.Twitter || (Fily.Twitter = {}));
})(Fily || (Fily = {}));
